import produce from "immer";
import { Reducer } from "redux";
import { IModuleSettingState, initialModuleSettingState } from "./moduleSetting.types";
import { LoadState } from "../../constants/enums";
import {
  FETCH_MODULE_SETTING_LIST_PROGRESS,
  FETCH_MODULE_SETTING_LIST_SUCCESS,
  FETCH_MODULE_SETTING_LIST_FAILED,
  CLEAR_MODULE_SETTING_STATE,
} from "./moduleSettingActions";

export const moduleSettingReducer: Reducer<IModuleSettingState> = (
  state = initialModuleSettingState,
  action
) => {
  switch (action.type) {
    case FETCH_MODULE_SETTING_LIST_PROGRESS:
      return produce(state, (draft) => {
        draft.loading = LoadState.InProgress;
      });

    case FETCH_MODULE_SETTING_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draft) => {
        draft.loading = LoadState.Loaded;
        draft.list = data;
        draft.totalRecords = totalRecords;
      });
    }

    case FETCH_MODULE_SETTING_LIST_FAILED:
      return produce(state, (draft) => {
        draft.loading = LoadState.Failed;
      });

    case CLEAR_MODULE_SETTING_STATE:
      return initialModuleSettingState;

    default:
      return state;
  }
};
